import { createSlice } from '@reduxjs/toolkit';

const zoomSlice = createSlice({
    name: 'zoom',
    initialState: {
        loading: false,
        slots: [],
        currentLiveSession: null,
        latestPastSession: null,
        zoomConfigured: false,
        courseZoomEnabled: false,
        slotsLoaded: false,
        activeSessionId: null,
        joinCredentials: null,
        recordingUrl: null,
        recordingSessionId: null,
        videoMode: 'idle',
        inMeeting: false,
        error: null,
        sidebarTab: 'chat',
    },
    reducers: {
        setZoomLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setZoomSlotsData: (state, { payload }) => {
            state.slots = payload.slots || [];
            state.currentLiveSession = payload.currentLiveSession || null;
            state.latestPastSession = payload.latestPastSession || null;
            state.slotsLoaded = true;
            if (payload.zoomConfigured !== undefined) {
                state.zoomConfigured = payload.zoomConfigured;
            }
            if (payload.zoomEnabled !== undefined) {
                state.courseZoomEnabled = payload.zoomEnabled;
            }
        },
        setJoinCredentials: (state, { payload }) => {
            state.joinCredentials = payload;
            state.activeSessionId = payload?.session?._id || null;
            state.videoMode = 'live';
            state.inMeeting = true;
            // Al entrar a la clase, lo relevante son los conectados a la llamada.
            state.sidebarTab = 'live';
        },
        setRecording: (state, { payload }) => {
            if (state.joinCredentials || state.inMeeting || state.videoMode === 'live') {
                return;
            }
            state.recordingUrl = payload.playUrl;
            state.recordingSessionId = payload.sessionId;
            state.videoMode = 'replay';
            state.inMeeting = false;
            state.joinCredentials = null;
            state.sidebarTab = 'chat';
        },
        closeReplay: (state) => {
            state.recordingUrl = null;
            state.recordingSessionId = null;
            if (state.videoMode === 'replay') {
                state.videoMode = 'idle';
            }
            state.sidebarTab = 'classes';
        },
        setVideoMode: (state, { payload }) => {
            state.videoMode = payload;
        },
        setActiveSessionId: (state, { payload }) => {
            state.activeSessionId = payload;
        },
        setInMeeting: (state, { payload }) => {
            state.inMeeting = payload;
        },
        setZoomError: (state, { payload }) => {
            state.error = payload;
        },
        setSidebarTab: (state, { payload }) => {
            state.sidebarTab = payload;
        },
        leaveMeeting: (state) => {
            state.inMeeting = false;
            state.joinCredentials = null;
            if (state.videoMode === 'live') {
                state.videoMode = 'idle';
            }
        },
        resetZoom: () => ({
            loading: false,
            slots: [],
            currentLiveSession: null,
            latestPastSession: null,
            zoomConfigured: false,
            courseZoomEnabled: false,
            slotsLoaded: false,
            activeSessionId: null,
            joinCredentials: null,
            recordingUrl: null,
            recordingSessionId: null,
            videoMode: 'idle',
            inMeeting: false,
            error: null,
            sidebarTab: 'chat',
        }),
    },
});

export const {
    setZoomLoading,
    setZoomSlotsData,
    setJoinCredentials,
    setRecording,
    closeReplay,
    setVideoMode,
    setActiveSessionId,
    setInMeeting,
    setZoomError,
    setSidebarTab,
    leaveMeeting,
    resetZoom,
} = zoomSlice.actions;

export default zoomSlice.reducer;
